import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { db, collection, addDoc } from '../LoginComp/firebase'; // Import Firestore functions
import './contact.css';



function ContactUs() {
  // Form data state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
    message: '',
  });

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare data for Firestore
    const contactData = {
      name: formData.name,
      email: formData.email,
      address: formData.address,
      phone: formData.phone,
      message: formData.message,
      timestamp: new Date(),
    };

    try {
      // Save to Firestore
      await addDoc(collection(db, "contacts"), contactData);
      console.log("Contact saved to Firestore");

      // Send email using EmailJS
      await emailjs.send('service_scsow9d', 'template_yggnfns', contactData, '3OStkO26YAh7AoFR9');
      alert('Thank you for your inquiry. We will get back to you soon!');

      // Reset form after submission
      setFormData({
        name: '',
        email: '',
        address: '',
        phone: '',
        message: '',
      });
    } catch (error) {
      console.error("Error saving contact:", error);
      alert('There was an error submitting your inquiry. Please try again.');
    }
  };

  return (
<>

    <div className="contactus-details-container">



      <h1 className="heading-details-toplayer">Contact Us</h1>

      <div className="details-contactus">
        <h4 className="heading-h4-details">Head Office</h4>
        <p className="para-details"><strong>Address:</strong> 932 Maradana Road, Colombo 08</p>
        <p className="para-details"><strong>Email:</strong>
          <a href="mailto:ecinstitute@gmail.com" className="text-decoration-none text-dark">
            ecinstitute@gmail.com
          </a>
        </p>
        <p><strong>Phone:</strong> +94 112 682 277 / +94 773 440 937</p>
        
        <div className="google-map-container">
          <iframe
            title="Location of Eye Care Institute"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.751303437473!2d79.86938077448274!3d6.920306318426057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259744a1d7131%3A0x614fbd9988cf7417!2sEye%20Care%20Institute!5e0!3m2!1sen!2slk!4v1733109997309!5m2!1sen!2slk"
            width="100%"
            height="450"
            style={{ border: '0' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <div className="contactus-form-container">
        <h4 className="contactus-heading">INQUIRY FORM</h4>
        <form onSubmit={handleSubmit}>
          <div className="contact-form-field">
            <label htmlFor="name" className="form-label">Name</label>
            <input type="text" id="name" name="name" className="form-control-contact"
              placeholder="Enter your name" value={formData.name} onChange={handleChange} required />
          </div>

          <div className="contact-form-field">
            <label htmlFor="email" className="form-label">Email</label>
            <input type="email" id="email" name="email" className="form-control-contact"
              placeholder="Enter your email" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="contact-form-field">
            <label htmlFor="address" className="form-label">Address</label>
            <input type="text" id="address" name="address" className="form-control-contact"
              placeholder="Enter your address" value={formData.address} onChange={handleChange} />
          </div>

          <div className="contact-form-field">
            <label htmlFor="phone" className="form-label">Phone Number</label>
            <input type="tel" id="phone" name="phone" className="form-control-contact"
              placeholder="Enter your phone number" required maxLength="10" pattern="\d{10}"
              value={formData.phone} onChange={handleChange} />
          </div>

          <div className="contact-form-field">
            <label htmlFor="message" className="form-label">Message</label>
            <textarea id="message" name="message" className="form-control-contact" rows="4"
              placeholder="Write your message here" value={formData.message} onChange={handleChange}></textarea>
          </div>

          <button type="submit" className="button-contactus">Submit</button>
        </form>
      </div>
    </div>
    </>
  );
}

export default ContactUs;
